<template>
  <v-navigation-drawer app v-model="drawer" :width="drawerWidth" class="customer-sidebar"> <!-- dark color="tertiary" -->
    <v-card tile flat :to="{ name: 'Customer' }" color="transparent" class="sidebar-header">
      <v-container class="pt-2 pb-0 px-0">
        <v-row justify="center" class="pb-1" no-gutters>
          <v-img src="/api2/Report/logo" height="52" max-width="110" contain :alt="userInfo.Provider.CompanyName"
            position="center">
          </v-img>
        </v-row>
        <v-row justify="center" class="py-1" style="background-color: rgb(0 0 0 / 3%);" no-gutters>
          {{ $t("customer.portal.title") }}
        </v-row>
      </v-container>
    </v-card>
    <v-divider />

    <v-list dense class="sidebar-nav py-0">
      <!-- 
      <NavTile :title="$t('text.home')" icon="mdi-home" :route="{ name: 'FrontPage' }">
      </NavTile>
      -->

      <!-- 
      <NavTile :title="'Shop'" icon="mdi-shopping" :route="{ name: 'Shop' }" :count="shoppingCartCount">
      </NavTile>
      -->
      <NavTile :title="$t('route.Machines')" icon="mdi-washing-machine" :route="{ name: 'MachineList' }">
      </NavTile>
      <NavTile :title="$t('text.shopping_cart')" icon="mdi-cart" :route="{ name: 'ShoppingCart' }"
        :count="shoppingCartCount">
      </NavTile>
      <NavTile :title="$t('text.history')" icon="mdi-history" :route="{ name: 'JobList' }" :count="openJobsCount"
        :countColor="'blue'">
      </NavTile>
      <NavTile :title="$t('text.organization')" icon="mdi-domain" :route="{ name: 'Organization' }">
      </NavTile>
      <!-- 
      <NavTile :title="$t('text.more')" icon="mdi-dots-horizontal" :route="{ name: 'Organization' }">
      </NavTile>
      -->
    </v-list>

    <v-row no-gutters class="sidebar-bottom">
      <v-col>
        <AccountButton />
        <v-card tile flat class="text-center py-1 powered-by" href="https://www.qwips.no" target="_blank">
          <small>Powered by <b>Qwips</b></small>
        </v-card>
      </v-col>
    </v-row>
  </v-navigation-drawer>
</template>


<script>
import AccountButton from "@/components/AccountButton.vue";
import AuthStoreMixin from "@/helpers/mixins/AuthStoreMixin";
//import GlobalSearchField from "@/components/GlobalSearchField.vue";
//import ShoppingCartButton from "@/components/ShoppingCartButton.vue";
import NavTile from "@/components/NavTile.vue";

export default {
  name: "SideBar",
  mixins: [AuthStoreMixin],
  components: {
    AccountButton,
    //GlobalSearchField,
    //ShoppingCartButton,
    NavTile,
  },

  data() {
    return {
      drawer: true,
      drawerWidth: 130,
    };
  },

  mounted() { },

  methods: {},

  computed: {
    userInfo() {
      if (this.authUserInfo) return this.authUserInfo;
      return { Customer: {}, Provider: {} };
    },

    shoppingCartCount() {
      return this.shoppingCartItemCount;
    },

    openJobsCount() {
      return this.openJobsCountValue;
    },
  },

  watch: {},
};
</script>

<style lang="scss" scoped>
.customer-sidebar {
  border-right: 1px solid rgba(0, 0, 0, 0.08);
}

.sidebar-header {
  color: rgba(0, 0, 0, 0.82);
}

.sidebar-nav {
  padding-bottom: 112px !important;
}

.sidebar-bottom {
  bottom: 0;
  left: 0;
  position: absolute;
  right: 0;
  z-index: 100;
}

.powered-by {
  background-color: rgba(0, 0, 0, 0.07) !important;
}

.powered-by small {
  font-weight: 400;
  opacity: 0.72;
}
</style>